'use strict';
import {MainRouteComponent} from './main-route.component.js';
import MainService from './main-route.service.js';
import angular from 'angular';
import ngRoute from 'angular-route';

/*@ngInject*/
const rutes = function routes($routeProvider) {
    $routeProvider.when('/', {
        template: '<main-route util-data="$resolve.utilData.data"></main-route>',
        resolve: {
            utilData: getUtilData
        }
    });
    
    function getUtilData(MainService) {
        return MainService.getUtilData();
    }
};

export default angular.module('pizzutoAutopartesApp.main', [ngRoute])
    .config(rutes)
    .service('MainService', MainService)
    .component(MainRouteComponent.selector, MainRouteComponent)
    .name;



// WEBPACK FOOTER //
// ./client/app/main-route/index.js